import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { hash } from 'rsvp';

export default class DevicesRoute extends Route 
{
	@service store;
	
	async model(params) 
	{	
		const events = await this.store.findAll('Event');
		const devices = await this.store.findAll('Device');
		
		for(const device of devices)
		{
			const event = await device.EventId;
			if(event != null)
			{
				this.store.findRecord('Event', event.id);
			}
		}
			
		return {
			events: events,
			devices: devices
		}
	}
}
